/**
 * Directional tilt up gesture
 * @module gestures/transforms/tiltUp
 */
import { createTiltGesture } from './tiltFactory.js';
export default createTiltGesture('up');
